// extracted by mini-css-extract-plugin
export var border = "accordion-module--border--b9393";
export var content = "accordion-module--content--2bed1";
export var header = "accordion-module--header--d88e5";
export var icon = "accordion-module--icon--97059";
export var transparent = "accordion-module--transparent--854bd";
export var white = "accordion-module--white--3b2fc";